import $ from 'jquery'

$(document).ready(function () {
  // Category
  if ($('body').hasClass('blog')) {
    $('ul.categories').on('click', 'li.filter', function () {
      const value = ($(this).hasClass('selected')) ? '' : $(this).attr('data-value')
      composeUrl('category_n', value)
    })
  }

  // Pagination
  /*
  $('span.page-number').on('click', function () {
    const value = $(this).attr('data-value')
    composeUrl('page', value)
  })
  */
})

function composeUrl (key, value) {
  const url = new URL(document.location.href)

  // Remove element if is already present and values is empty
  if (url.searchParams.has(key) && value === '') {
    url.searchParams.delete(key)
  } else {
    url.searchParams.set(key, value)
  }

  // Check for configurable param
  if (key === 'configurable' && value === false) {
    url.searchParams.delete(key)
  }

  // Check pagination offsets
  if (url.searchParams.has('page')) {
    const max = $('input[name="max-pages"]').val() ?? 1
    if (url.searchParams.get('page') > max) {
      url.searchParams.delete('page')
    }
  }

  // Redirect
  document.location = url.href
}
